import { defineStore } from "pinia";
import { useUserStore } from "@/stores/UserStore";
import mainAPI from "@/api/mainAPI";
import MyPlugin from "@/plugins/plugin";
import languages from "@/configs/language";
import { useGeneralStore } from "@/stores/GeneralStore";

export const usePartnerStore = defineStore("PartnerStore", {
  state: () => ({
    selectedPartnerData: {},
    partnerData: [],
    partnerDataFleet: [],
    partnerDataOrder: [],
    vendorPicData: [],
    functionalityData: [],
    driverData: [],
  }),
  getters: {},
  actions: {
    async getPartner(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETVENDOR",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.partnerData,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async getPartnerFleet(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETPARTNERFLEET",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.partnerDataFleet,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async getPartnerOrder(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETPARTNERORDER",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.partnerDataFleet,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async getPartnerById(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETVENDOR",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        this.selectedPartnerData = res.data.data[0];
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async storePartner(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "STOREVENDOR",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async updatePartner(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "UPDATEVENDOR",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async destroyPartner(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "DESTROYVENDOR",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async getVendorPic(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETVENDORPIC",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.vendorPicData,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async getFunctionality(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETFUNCTIONALITY",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.functionalityData,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async storeVendorPic(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "STOREVENDORPIC",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async updateVendorPic(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "UPDATEVENDORPIC",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async destroyVendorPic(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "DESTROYVENDORPIC",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    // DRIVER
    async getVendorDriver(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETVENDORDRIVER",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.driverData,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async getBank(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETBANK",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
          data: this.driverData,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async storeVendorDriver(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "STOREVENDORDRIVER",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async storeUserDriver(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "STOREUSERDRIVER",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async destroyVendorDriver(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "DESTROYVENDORDRIVER",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },

    async updateVendorDriver(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "UPDATEVENDORDRIVER",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success" };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },
  },
});
